import React from 'react';
import { useTranslation } from 'react-i18next';
import './Lang.scss';
import classnames from 'classnames';

function Lang() {
  const [, i18n] = useTranslation();

  const onChange = (lang) => {
    i18n.changeLanguage(lang);
  }

  const lang = i18n.language


  return (
    <div className="btn-lang">
      <button className={classnames({ active: lang === 'it' })} onClick={() => onChange('it')}>ITA</button> |
      <button className={classnames({ active: lang === 'en' })} onClick={() => onChange('en')}>ENG</button>
    </div>
  );
}

export default Lang;
